import React, { useEffect } from 'react';
import {
	BrowserRouter as Router,
	Route,
} from 'react-router-dom';
import { createBrowserHistory } from 'history';

import Dashboard from './routes/Dashboard';
import BuildOnlyRoutes from './routes/BuildOnlyRoutes';
import MyApps from './routes/MyApps';
import { NotificationContainer } from 'components/Notification';
import appmaker from '@appmaker/core/index';
import { QueryParamProvider } from 'use-query-params';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

const queryClient = new QueryClient()
window.queryClient = queryClient;
function App() {
  const history = createBrowserHistory();

  useEffect(() => {
    appmaker.doAction('appmaker-analytics-track-page-view');
    history.listen(() => {
      appmaker.doAction('appmaker-analytics-track-page-view');
    });
  }, [history]);


  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
    <Router history={history}>
      <QueryParamProvider ReactRouterRoute={Route}>

        <NotificationContainer />
        <BuildOnlyRoutes Dashboard={Dashboard} MyApps={MyApps} />
      </QueryParamProvider>
    </Router>
    </QueryClientProvider>
  );
}

export default App;
